import { render, staticRenderFns } from "./PolyDialog.vue?vue&type=template&id=c0aa89c4&scoped=true&"
import script from "./PolyDialog.vue?vue&type=script&lang=ts&"
export * from "./PolyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PolyDialog.vue?vue&type=style&index=0&id=c0aa89c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aa89c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VProgressCircular,VSnackbar,VTextField,VTextarea})
